import React, { useEffect } from "react";
import Layout from "../../components/layout/Layout";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import DesktopMacIcon from "@mui/icons-material/DesktopMac";
import ListIcon from "@mui/icons-material/List";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import StorefrontIcon from "@mui/icons-material/Storefront";
import WifiIcon from "@mui/icons-material/Wifi";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import "./dashboard.css";
import { useDispatch, useSelector } from "react-redux";
import AreaChart from "../../components/charts/AreaChart";
import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { getPlaylist } from "../../Redux/Actions/playlistAction";
import { getScreens } from "../../Redux/Actions/screenAction";
import { getContent } from "../../Redux/Actions/contentAction";
import { getPaymentDashboard } from "../../Redux/Actions/paymentAction";
import { getChangeRequests } from "../../Redux/Actions/changeRequestAction";
import { useNavigate } from "react-router-dom";

function Dashboard({ user }) {
  const theme = createTheme({
    palette: {
      primary: { main: "#0971f1" },
      url: { main: "#FD2254" },
      image: { main: "#FF6A00" },
      video: { main: "#551fff" },
    },
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { content, isContentLoading } = useSelector(s => s.Content);
  const { playlist, isPlaylistLoading } = useSelector(s => s.Playlist);
  const { screens, screenLoading } = useSelector(s => s.Screen);
  const { users } = useSelector(s => s.User);
  const { dashboard: payDashboard } = useSelector(s => s.Payment);
  const { requests: changeRequests } = useSelector(s => s.ChangeRequest);

  const onlineScreens  = screens.filter(s => s.status === true).length;
  const offlineScreens = screens.filter(s => s.status !== true).length;
  const pendingRequests = changeRequests.filter(r => r.status === 'pending');

  useEffect(() => {
    dispatch(getContent(user?._id));
    dispatch(getPlaylist(user?._id));
    dispatch(getScreens(user?._id));
    dispatch(getPaymentDashboard(user?._id));
    dispatch(getChangeRequests(user?._id));
  }, []);

  const fmt = (n) => `$${(n || 0).toLocaleString()}`;

  return (
    <Layout title="Dashboard" user={user}>
      <ThemeProvider theme={theme}>
        <div style={{ padding: '8px' }}>

          {/* Row 1: 4 existing stat cards */}
          <Box sx={{ background:'white', borderRadius:'20px', boxShadow:'0px 4px 20px rgba(0,0,0,0.06)', p:2, mb:2 }}>
            <Grid container spacing={1}>
              {[
                { icon: <TextSnippetIcon sx={{ color:'#FF6A00' }}/>, bg:'#FFF2E9', label:'Content', value: isContentLoading ? '...' : content.length },
                { icon: <DesktopMacIcon sx={{ color:'#551fff' }}/>, bg:'#EDE8FF', label:'Screens', value: screenLoading ? '...' : screens.length },
                { icon: <ListIcon sx={{ color:'#00B7FE' }}/>, bg:'#EAF9FF', label:'Playlist', value: isPlaylistLoading ? '...' : playlist.length },
                { icon: <PersonAddIcon sx={{ color:'#FD2254' }}/>, bg:'#FFEBEF', label:'Users', value: users.length },
              ].map(({ icon, bg, label, value }) => (
                <Grid item xs={6} sm={3} key={label}>
                  <Box sx={{ display:'flex', alignItems:'center', gap:1.5, p:1 }}>
                    <Box sx={{ background: bg, borderRadius:'12px', p:1.5, display:'flex' }}>{icon}</Box>
                    <Box>
                      <Typography sx={{ fontSize:12, color:'#92959E', fontWeight:700 }}>{label}</Typography>
                      <Typography sx={{ fontSize:20, fontWeight:700, color:'#15192C' }}>{value}</Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>

          <Grid container spacing={2}>
            {/* Left: Chart + Screen Status */}
            <Grid item xs={12} lg={8}>
              <Box sx={{ background:'white', borderRadius:'20px', p:2, boxShadow:'0px 4px 20px rgba(0,0,0,0.06)', mb:2 }}>
                <AreaChart />
              </Box>

              {/* Screen Status Widget */}
              <Box sx={{ background:'white', borderRadius:'16px', p:2.5, boxShadow:'0px 4px 20px rgba(0,0,0,0.06)' }}>
                <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:2 }}>
                  <Typography sx={{ fontWeight:700, fontSize:15, color:'#15192C' }}>Screen Status</Typography>
                  <button onClick={() => navigate('/screen')} style={{ background:'none', border:'none', color:'#551FFF', fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', gap:4, fontWeight:600 }}>
                    View All <ArrowForwardIcon style={{ fontSize:14 }} />
                  </button>
                </Box>
                <Grid container spacing={1.5}>
                  <Grid item xs={4}>
                    <Box sx={{ background:'#f8f7ff', borderRadius:10, p:2, textAlign:'center', border:'1.5px solid rgba(85,31,255,0.1)' }}>
                      <Typography sx={{ fontSize:26, fontWeight:800, color:'#551FFF' }}>{screens.length}</Typography>
                      <Typography sx={{ fontSize:11, color:'#92959E', fontWeight:600 }}>TOTAL</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box sx={{ background:'#f0fdf4', borderRadius:10, p:2, textAlign:'center', border:'1.5px solid #bbf7d0', cursor:'pointer' }}
                      onClick={() => navigate('/screen')}>
                      <Box sx={{ display:'flex', justifyContent:'center', alignItems:'center', gap:0.5 }}>
                        <WifiIcon sx={{ color:'#22c55e', fontSize:18 }} />
                        <Typography sx={{ fontSize:26, fontWeight:800, color:'#22c55e' }}>{onlineScreens}</Typography>
                      </Box>
                      <Typography sx={{ fontSize:11, color:'#16a34a', fontWeight:600 }}>ONLINE</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box sx={{ background:'#fef2f2', borderRadius:10, p:2, textAlign:'center', border:'1.5px solid #fecaca', cursor:'pointer' }}
                      onClick={() => navigate('/screen?filter=offline')}>
                      <Box sx={{ display:'flex', justifyContent:'center', alignItems:'center', gap:0.5 }}>
                        <WifiOffIcon sx={{ color:'#ef4444', fontSize:18 }} />
                        <Typography sx={{ fontSize:26, fontWeight:800, color:'#ef4444' }}>{offlineScreens}</Typography>
                      </Box>
                      <Typography sx={{ fontSize:11, color:'#dc2626', fontWeight:600 }}>OFFLINE</Typography>
                    </Box>
                  </Grid>
                </Grid>
                {offlineScreens > 0 && (
                  <Box sx={{ mt:1.5, p:1.5, background:'#fef2f2', borderRadius:8, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <Typography sx={{ fontSize:12, color:'#dc2626', fontWeight:600 }}>
                      {offlineScreens} screen{offlineScreens > 1 ? 's' : ''} offline — check connectivity
                    </Typography>
                    <button onClick={() => navigate('/screen?filter=offline')}
                      style={{ background:'#ef4444', color:'white', border:'none', borderRadius:6, padding:'4px 12px', fontSize:12, cursor:'pointer', fontWeight:600 }}>
                      View Offline
                    </button>
                  </Box>
                )}
              </Box>
            </Grid>

            {/* Right: Payment Summary + Store Requests */}
            <Grid item xs={12} lg={4}>
              {/* Payment Summary */}
              <Box sx={{ background:'white', borderRadius:'16px', p:2.5, boxShadow:'0px 4px 20px rgba(0,0,0,0.06)', mb:2 }}>
                <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:2 }}>
                  <Typography sx={{ fontWeight:700, fontSize:15, color:'#15192C' }}>Payment Summary</Typography>
                  <button onClick={() => navigate('/payment')} style={{ background:'none', border:'none', color:'#551FFF', fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', gap:4, fontWeight:600 }}>
                    Details <ArrowForwardIcon style={{ fontSize:14 }} />
                  </button>
                </Box>
                {[
                  { label:'Received this month', value: fmt(payDashboard?.received), color:'#22c55e', bg:'#f0fdf4' },
                  { label:'Pending', value: fmt(payDashboard?.pending), color:'#f59e0b', bg:'#fffbeb' },
                  { label:'Overdue', value: fmt(payDashboard?.overdue), color:'#ef4444', bg:'#fef2f2' },
                  { label:'Expected next month', value: fmt(payDashboard?.nextMonthExpected), color:'#551FFF', bg:'rgba(85,31,255,0.06)' },
                ].map(({ label, value, color, bg }) => (
                  <Box key={label} sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', p:'8px 12px', background:bg, borderRadius:8, mb:1 }}>
                    <Typography sx={{ fontSize:12, color:'#555' }}>{label}</Typography>
                    <Typography sx={{ fontSize:14, fontWeight:700, color }}>{value}</Typography>
                  </Box>
                ))}
                <Box sx={{ mt:1, p:1.5, background:'rgba(85,31,255,0.04)', borderRadius:8, display:'flex', justifyContent:'space-between' }}>
                  <Typography sx={{ fontSize:12, color:'#555' }}>New stores this month</Typography>
                  <Typography sx={{ fontSize:14, fontWeight:700, color:'#551FFF' }}>{payDashboard?.newStoresThisMonth || 0}</Typography>
                </Box>
              </Box>

              {/* Store Change Requests */}
              <Box sx={{ background:'white', borderRadius:'16px', p:2.5, boxShadow:'0px 4px 20px rgba(0,0,0,0.06)' }}>
                <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:1.5 }}>
                  <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
                    <Typography sx={{ fontWeight:700, fontSize:15, color:'#15192C' }}>Store Requests</Typography>
                    {pendingRequests.length > 0 && (
                      <Box sx={{ background:'#ef4444', color:'white', borderRadius:'999px', fontSize:11, fontWeight:700, px:1, py:0.2, minWidth:20, textAlign:'center' }}>
                        {pendingRequests.length}
                      </Box>
                    )}
                  </Box>
                  <button onClick={() => navigate('/store')} style={{ background:'none', border:'none', color:'#551FFF', fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', gap:4, fontWeight:600 }}>
                    View <ArrowForwardIcon style={{ fontSize:14 }} />
                  </button>
                </Box>
                {pendingRequests.length === 0 ? (
                  <Typography sx={{ fontSize:13, color:'#bbb', textAlign:'center', py:2 }}>No pending requests</Typography>
                ) : pendingRequests.slice(0, 4).map(r => (
                  <Box key={r._id} sx={{ p:1.5, background:'#faf9ff', borderRadius:8, mb:1, borderLeft:'3px solid #551FFF' }}>
                    <Typography sx={{ fontSize:12, fontWeight:700, color:'#15192C' }}>{r.store?.name || 'Store'}</Typography>
                    <Typography sx={{ fontSize:11, color:'#92959E', mt:0.3 }}>{r.changeDetails?.slice(0, 60)}{r.changeDetails?.length > 60 ? '...' : ''}</Typography>
                    <Box sx={{ display:'flex', justifyContent:'space-between', mt:0.5 }}>
                      <span style={{ fontSize:10, background:'#ede9fe', color:'#7c3aed', padding:'2px 6px', borderRadius:4, fontWeight:600 }}>{r.type?.replace('_', ' ')}</span>
                      <span style={{ fontSize:10, color:'#aaa' }}>{new Date(r.createdAt).toLocaleDateString()}</span>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Grid>
          </Grid>
        </div>
      </ThemeProvider>
    </Layout>
  );
}

export default Dashboard;
